import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const ScheduleTaskPropTypes = PropTypes.shape({
  _id: PropTypes.string,
  taskName: PropTypes.string,
});

export const ScheduleTaskDefaultProps = {
  taskName: '',
  subTasks: [
    {
      subTaskName: "",
      assignTo: "Self",
      users: [],
      frequency: "Daily",
      selectedDays: ["M", "T", "W", "TH", "F"],
      startDate: "",
      initiationType: "Dependency",
      time: "",
      duration: 0,
      durationUnit: "Hours",
      _id: undefined
    }
  ],
  _id: undefined
};

export const ScheduleTaskYupSchema = Yup.object().shape({
  taskName: Yup.string().required('Task name is required'),
  subTasks: Yup.array()
    .of(
      Yup.object().shape({
        subTaskName: Yup.string().required('Subtask name is required'),
        assignTo: Yup.string().required('Assign To is required'),
        // users: Yup.array().when('assignTo', {
        //   is: (val) => Array.isArray(val) ? val.includes('Other') : val === 'Other',
        //   then: (schema) => schema.min(1, 'Please assign at least one user'),
        //   otherwise: (schema) => schema.notRequired(),
        // }),
        frequency: Yup.string().required('Frequency is required'),
        // selectedDays: Yup.array().when('frequency', {
        //   is: (val) => Array.isArray(val) ? val.includes('Custom') : val === 'Custom',
        //   then: (schema) => schema.min(1, 'Please select at least one day'),
        //   otherwise: (schema) => schema.notRequired(),
        // }),
        // startDate: Yup.date().nullable(), // if used
        initiationType: Yup.string().required('Initiation type is required'),
        // time: Yup.string().when('initiationType', (initiationType, schema) => {
        //   return initiationType === 'Fixed'
        //     ? Yup.string().required('Time is required for fixed initiation')
        //     : Yup.string().notRequired();
        // }),
        duration: Yup.string()
          .required('Duration is required')
          .matches(/^\d+(\.\d{1,2})?$/, 'Duration must be a number with up to 2 decimal places'),
        durationUnit: Yup.string()
          .required('Duration unit is required'),
      })
    )
    .min(1, 'At least one subtask is required')
});
export const tasksList = [
  {
    task: "Task A",
    subtask: "ST-A01",
    assignedTo: "Self",
    frequency: "Daily",
    days: ["M", "T", "W"],
    initiation: "Fixed Time",
    scheduledTime: "10:00 AM",
    dependentSubtask: "NA",
    duration: "0.5 hr",
  },
  {
    task: "Task A",
    subtask: "ST-A02",
    assignedTo: "Monis",
    frequency: "Weekly",
    days: ["7 June"],
    initiation: "Fixed Time",
    scheduledTime: "12:00 PM",
    dependentSubtask: "NA",
    duration: "1 hr",
  },
  {
    task: "Task B",
    subtask: "ST-B01",
    assignedTo: "Danish",
    frequency: "Custom",
    days: ["T", "Th", "F"],
    initiation: "Dependency",
    scheduledTime: "NA",
    dependentSubtask: "Root subtask",
    duration: "0.5",
  },

];
export default {
  ScheduleTaskDefaultProps,
  ScheduleTaskPropTypes,
  ScheduleTaskYupSchema,
};
